import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import templeIcon from '../assets/images/icons/temple-icon.svg'; // Commented out as unused

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md fixed w-full z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src={`${process.env.PUBLIC_URL}/images/cambodia-temple.png`}
              alt="Tuk Tuk Restaurant Logo"
              className="h-10 mr-3"
            />
            <span className="font-display text-2xl font-bold text-tuktuk-brown">
              Tuk Tuk Restaurant
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8">
            <Link to="/" className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors">
              Home
            </Link>
            <Link to="/menu" className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors">
              Menu
            </Link>
            <Link to="/about" className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors">
              About Us
            </Link>
            <Link to="/farm-tours" className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors">
              Farm Tours
            </Link>
            <Link to="/gallery" className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors">
              Gallery
            </Link>
            <Link to="/reservations" className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors">
              Reservations
            </Link>
            <Link to="/contact" className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors">
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              type="button"
              className="text-gray-500 hover:text-gray-600 focus:outline-none"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                {isMenuOpen ? (
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                  />
                ) : (
                  <path
                    fillRule="evenodd"
                    d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/menu"
                className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Menu
              </Link>
              <Link
                to="/about"
                className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </Link>
              <Link
                to="/farm-tours"
                className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Farm Tours
              </Link>
              <Link
                to="/gallery"
                className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Gallery
              </Link>
              <Link
                to="/reservations"
                className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Reservations
              </Link>
              <Link
                to="/contact"
                className="font-body font-medium text-gray-700 hover:text-tuktuk-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 